import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import TransactionFilterComp from '~/apps/shared/containers/transactions/TransactionFilter';
import { parseTransactionFilter, transactionFilterParams } from '~/apps/shared/services/qsfilter';
import { setTransactionsCurrentPage } from '~/apps/shared/actions/transactions';


const TransactionFilter = (props) => {
  const { route: { params }, dispatch } = props;
  const filter = parseTransactionFilter(params);

  return (
    <CurrentOrgInjector
      component={TransactionFilterComp}
      filter={filter}
      onLocationChange={(locationId: string) => {
        filter.locationId = locationId;
        navigate('receiver.admin.transactions', transactionFilterParams(filter));
      }}
      onFilter={(q: string) => {
        filter.q = q;
        navigate('receiver.admin.transactions', transactionFilterParams(filter));
        dispatch(setTransactionsCurrentPage(0));
      }}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(createRouteNodeSelector('receiver.admin'), mapDispatchToProps)(TransactionFilter);
